import { lazy, Suspense } from 'react';
import { Route, Routes } from "react-router-dom"

const Home = lazy(() => import('../pages/Home'))
const Services = lazy(() => import('../pages/Services'))
const About = lazy(() => import('../pages/About'))
const Contact = lazy(() => import('../pages/Contact'))
const Sectors = lazy(() => import('../pages/Sectors'))
const Choose = lazy(() => import('../pages/Choose'))
const Solutions = lazy(() => import('../pages/Solutions'))
const SolutionDetails = lazy(() => import('../pages/SolutionsDetails'))
const NotFound  = lazy(() => import('../pages/NotFound'))

// import Home from '../pages/Home';
// import Services from '../pages/Services';
// import About from '../pages/About';
// import Contact from '../pages/Contact';
// import Sectors from '../pages/Sectors';
// import Choose from '../pages/Choose';
// import Solutions from '../pages/Solutions';
// import SolutionDetails from '../pages/SolutionsDetails';

export default function AppRouter() {
    return (
        <Suspense fallback={<div className="min-h-screen bg-black" />}>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/about-us" element={<About />} />
                <Route path="/contact-us" element={<Contact />} />
                <Route path="/solutions" element={<Solutions />} />
                <Route path="/solutions/:slug" element={<SolutionDetails />} />
                <Route path="/sectors" element={<Sectors />} />
                <Route path="/why-choose-us" element={<Choose />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Suspense>
    )
}